export default function HowIsItUsed() {
    return {
        title: 'How is it used',
        paragraphs: [
            '<div>DI insurance is used as source of income if income stops due to an illness or injury. DI insurance can also provide operating expense reimbursement for business owners if they are unable to work do to an illness or injury.<div>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/disability-insurance/HowIsItUsedData.js